<!--
  多图上传组件
  用法：<upload-multiple v-model:file-list="list" :limit="10" />
-->
<template>
  <div class="upload-multiple">
    <el-upload
      action=""
      :http-request="customUpload"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
      list-type="picture-card"
      :accept="accept"
    >
      <el-icon><Plus /></el-icon>
    </el-upload>
    <el-dialog v-model="dialogVisible" top="5vh">
      <img w-full :src="dialogUrl" alt="" class="preview-img" />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  fileList: { type: Array, default: () => [] },
  limit:    { type: Number, default: 10 },
  accept:   { type: String, default: 'image/*' }
})
const emit = defineEmits(['update:fileList'])

const dialogVisible = ref(false)
const dialogUrl = ref('')

watch(() => props.fileList, val => emit('update:fileList', val), { deep: true })

const customUpload = (options) => {
  const { file, onSuccess } = options
  if (file.size > 5 * 1024 * 1024) {
    ElMessage.error('图片不能超过 5MB')
    return
  }
  // 生成预览 URL
  file.url = URL.createObjectURL(file.raw)
  onSuccess(file)
}

const handleExceed = () => {
  ElMessage.warning(`最多上传 ${props.limit} 张图片`)
}

const handlePictureCardPreview = (file) => {
  dialogUrl.value = file.url
  dialogVisible.value = true
}
</script>

<style scoped>
.preview-img { width: 100%; height: auto; display: block; }
:deep(.el-upload--picture-card) { width: 80px; height: 80px; line-height: 80px; }
:deep(.el-upload-list--picture-card .el-upload-list__item) { width: 80px; height: 80px; }
</style>
